export const QUOTE_TYPE_OPTIONS = [
	{ label: "All Quotes", value: "All" },
	{ label: "Bulk Quotes", value: "Bulk" },
	{ label: "Individual Quotes", value: "Individual" },
];
